import React from "react";
import { IconBrowse, IconMyListings, IconSell, IconProfile } from "./Icons";

const BottomNav = ({ page, setPage, t }) => {
  return (
    <nav className="bottom-nav">
      <button
        className={`nav-item ${page === "browse" ? "active" : ""}`}
        onClick={() => setPage("browse")}
      >
        <IconBrowse filled={page === "browse"} />
        <span>{t.browse}</span>
      </button>

      <button
        className={`nav-item ${page === "mylistings" ? "active" : ""}`}
        onClick={() => setPage("mylistings")}
      >
        <IconMyListings filled={page === "mylistings"} />
        <span>{t.myListings}</span>
      </button>

      <button
        className={`nav-item sell-btn ${page === "sell" ? "active" : ""}`}
        onClick={() => setPage("sell")}
      >
        <IconSell filled={page === "sell"} />
        <span>{t.sell}</span>
      </button>

      <button
        className={`nav-item ${page === "profile" ? "active" : ""}`}
        onClick={() => setPage("profile")}
      >
        <IconProfile filled={page === "profile"} />
        <span>{t.profile}</span>
      </button>
    </nav>
  );
};

export default BottomNav;
